'use client';

import { cn } from '@/lib/shared/ui';
import { computeRelativePath } from '@/lib/shared/utils/docs';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';

type Props = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export const RelativeLink = (props: Props) => {
  const pathname = usePathname();

  // Adjust href by adding to the current pathname if a relative link is used (./)
  const href = computeRelativePath(pathname ?? '', props.href?.toString() || '');

  // Pass id through so footnote back-reference anchors (user-content-fnref-*) survive
  return (
    <Link href={href as string} className={cn('text-primary underline')} id={props.id}>
      {props.children}
    </Link>
  );
};
